import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ConjointArrows from './ConjointArrows';
import { useSelector } from 'react-redux';
import { getSorting } from '../stores/algos-list/getters';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    marginLeft: 4,
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',

      '&.sort-active': {
        color: 'var(--color-colorPrimary-main)',
      },
    },
  },
}));

const SortArrows = ({ dataKey = '', placeholder = true }) => {
  const { field = '', order = '' } = useSelector(getSorting);
  const dataMatch = field === dataKey;
  const showplaceHolder = !order || !dataMatch ? true : false;

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {dataMatch && order === 'ASC' && (
        <ArrowUpwardIcon className="sort-active" />
      )}
      {dataMatch && order === 'DSC' && (
        <ArrowDownwardIcon className="sort-active" />
      )}
      {placeholder && showplaceHolder && <ConjointArrows />}
    </div>
  );
};

export default SortArrows;
